module.exports = __webpack_public_path__ + "static/lepes2-26952bff95c4fa592306a3b333c7348f.png";